module.exports = __webpack_public_path__ + "img/wallet_03_safeguard.80ddc396.png";